'use client'

import { useEffect, useState } from 'react'
import CanadianBranding from './CanadianBranding'

export default function CanadianBrandingWrapper() {
  const [isCanadian, setIsCanadian] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    // For development, always show the branding
    if (process.env.NODE_ENV === 'development') {
      setIsCanadian(true)
      setIsLoading(false)
      return
    }

    // Check for Canadian visitors on the client side
    const checkCanadian = async () => {
      try {
        const response = await fetch('/api/check-country')
        if (response.ok) {
          const data = await response.json()
          setIsCanadian(data.isCanadian)
        }
      } catch (error) {
        console.error('Error checking country:', error)
      } finally {
        setIsLoading(false)
      }
    }

    checkCanadian()
  }, [])

  // In development, always show the branding
  if (process.env.NODE_ENV === 'development' && !isLoading) {
    return <CanadianBranding />
  }

  // In production, only show for Canadian visitors
  if (isLoading || !isCanadian) return null

  return <CanadianBranding />
}
